import { render } from "./App.vue?vue&type=template&id=296daaea"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=296daaea&lang=scss"
script.render = render

export default script